import { render, staticRenderFns } from "./HelperTagList.vue?vue&type=template&id=463497f9&scoped=true"
import script from "./HelperTagList.vue?vue&type=script&lang=js"
export * from "./HelperTagList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463497f9",
  null
  
)

export default component.exports